import { Icon } from '@fattureincloud/fic-design-system'
import {
  faEnvelope,
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons'
import parse from 'html-react-parser'
import React, { FC } from 'react'

import { httpRequest } from '../common/network'
import { Button } from '../layout_components/Button'
import { setVisible } from '../redux/features/chat/chatSlice'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { ChatContainer, ChatTitle } from './customComponents'
interface Props {
  type?: string
  id?: number
}
import { locale } from '../locales/locale'

const Chat: FC<Props> = (props: Props) => {
  const isVisible = useAppSelector((state) => state.chat.visible)
  const infoChatAuth = useAppSelector((state) => state.chat.info)
  const { openable, warning } = useAppSelector((state) => state.chat.config)
  const adminMode = useAppSelector((state) => state.adminMode.value)
  const dispatch = useAppDispatch()

  const openCustomerly = () => {
    if (adminMode || infoChatAuth?.attributes.is_support) {
      alert(locale('In questo modalità non è possibile aprire la chat.'))
      return
    }
    if (!openable) {
      alert(
        locale("Purtroppo in questo momento l'assistenza clienti è completamente occupata a causa di un numero eccezionalmente elevato di richieste.") + '\n' +
          locale('Ci scusiamo molto per il disagio e contiamo di ripristinare il supporto nel più breve tempo possibile.')
      )
      return
    }
    if (!isVisible) {
      httpRequest({
        method: 'POST',
        path: 'help/chat',
        data: { data: { [props.type + '_id']: props.id } },
      })
    }
    dispatch(setVisible(!isVisible))
  }

  return (
    <ChatContainer>
      <ChatTitle>{locale('Non trovi quello che stai cercando?')}</ChatTitle>
      <div className={'averageResponseTime'}>
        <span className={'iconContainer'}>
          <Icon icon={faExclamationTriangle} />
        </span>
        <span>{parse(warning)}</span>
      </div>
      <Button
        type={'text'}
        text={locale("Contatta l'assistenza")}
        iconLeft={faEnvelope}
        onClick={() => openCustomerly()}
        customClass={'assistance'}
      />
    </ChatContainer>
  )
}

export default Chat
